// PageHeader Component

/* eslint indent: 0 */

import React, { Component } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import currency from '../../../lib/currency.jsx'
import Button from '../../common/button/button.jsx'
import Tooltip from '../../common/tooltip/tooltip.jsx'
import SvgIcon from '../../common/svgicon/svgicon.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import Input from '../../common/input/input.jsx'
import ProgressBar from './progress-bar/index'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import FormDatePicker from '../../../common/form/form_datepicker/form_datepicker.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import convertToRangedDateLocalTime from '../../../lib/convertToRangedDateLocalTime/convertToRangedDateLocalTime.js'
import { Spinner } from '../../../common/common/spinner.jsx'

/*

  # Page Header Components
  ## Properties
   - projectSetting: null or object
    projectSettings =
      { useUniqueNo: true,
      isGenerated: false,
      isPmVisible: false,
      useProjectNo: true }
    If  projectSetting.useProjectNo = true, then show project numbers option is enabled and we want to render project numbers before project name
    *useUniqueNo is deprecated in favour of useProjectNo, and should be removed soon.
   - projectNumber: Number of the project (render if it exists)
   - title: Page title in translation format (String)
   - subtitle: Page Subtitle in translation format (String)
   - isTitleMultilingual: Set whether title and subtitle can be translated or not (Boolean)
   - icon: Icon name (String)
   - statInfos: List of stat infos (Array)
      - title : Title of info (String)
      - value : Value of info (Number)
      - isPrice : For formating as currency (Boolean)
      - isMultilingual : For non translatable texts (Boolean)
      - tooltipInfos: (Array of objects)
      - type: [row | column] (String)
      - hasSpliter: If it is true, top border will be shown (Boolean)
      - items: Array of sub items in each row (Array)
        - title: Title in translation format (String)
        - value: Value of item (String | Number)
        - isPrice: For formating as currency (Boolean)
        - showWarning: For formating as currency (Boolean)
        - suffixText: Text to show in front of item (String)
  - alignStatInfos: Show stat infos in top or bottom (String) - [top | bottom]
  - alignActions: Align actions to left or right or align with title - (String) - [left | right | title] - default: title
  - showGridList: Show grid or list button (Boolean)
  - isGridActive: If it is true it shows grid button else list button (Boolean)
  - onGridListToogle: Callback Function
  - actions: List of actions (Array)
      - ident: Unique identifier of action (String)
      - icon: Icon Name (String)
      - onClick: Callback Function
      - tooltip: Shows when hover it
      - tooltipPosition: Position of tooltip
      - href
      - target
      - hasConfirm
      - confirmTitle
      - type - Option to use either button or icon button, by default it will be icon button (String) - [button | 'info' | '']
      - if type === 'button', all the properties of button can be passed
  - showTabs: If it  is ture it shows tabs else none (Boolean)
  - activeTab: If it is true active tab will be hilighted (String)
  - tabs: List of tabs (Array)
      - ident: Identifier of the action (String)
      - title: Title of the tag (String)
  - onTabChange: Callback function
  - contentFilters: List of contentfilters (Array)
      - ident: Identifier of the action (String)
      - title: Title of the tag (String)
  - activeContentFilters: List of active content filters [Array of values]
  - onContentFilterChange: Callback function
  - hasFilter: Show or Hide filter (Boolean)
  - filters
    - type: label
    - label: Transable text (String)

    - ident: Identifier of the action (String)
    - type: option
    - options: List of content [Array of values]
    - isMulti: Boolean Variable [False]
    - value: Value of filters (Number)

    - ident: Identifier of the action (String)
    - type: tag
    - isMulti: Boolean Variable [True]
    - value: Value of filters (Number)

    - ident: Identifier of the action (String)
    - type: tag
    - isMulti: Boolean Variable [True]
    - value: List of tags [Array of values]

    - ident: Identifier of the action (String)
    - type: date
    - isMulti: Boolean Variable [True]
    - dateOptions
      - ident: Identifier of the action (String)
      - label: Transable text
      - value: Values of date (Number)
    - value: Values of filters (Numbers)
    - ident: Identifier of the action (String)

    - type: date
    - isMulti: Boolean Variables [True]
    - dateOptions
      - ident: Identifier of the action (String)
      - label: Transable text
      - value: Values of info (Numbers)
    - value: Values of Date (Numbers)
      - from: Values of from date (Numbers)
      - to: Values of to date (Numbers)
  - filterActions - Array of actions that will be shown filter main panel
    - All props of IconButton can we supplied here
  - onChangeFilter: callback function
*/

class PageHeader extends Component {
  constructor (props) {
    super(props)

    this.data = {
      currentPanel: this._getNextPannel(props), // main | filtermain | filter | filtersearch
      currentFilterIdent: null,
      keywordTag: '',
      keywordSearch: props.keywordSearch,
      options: [],
      message: null
    }

    this.state = {
      focusedIndex: -1
    }

    this._message = null
    this._messageTime = null
    this._canAutoOpenFilter = true
    this._timerSearchKeyword = null

    this._references = {}

    // Create references for actions if action has confirmation
    this._createReferencesForActions(props.actions, 'action')
    this._createReferencesForActions(props.rightActions, 'rightaction')
  }

  static get propTypes () {
    return {
      projectSetting: PropTypes.object,
      projectNumber: PropTypes.string,
      title: PropTypes.string,
      subtitle: PropTypes.string,
      icon: PropTypes.object,
      statInfos: PropTypes.array,
      showGridList: PropTypes.bool,
      isGridActive: PropTypes.bool,
      actions: PropTypes.array,
      showTabs: PropTypes.bool,
      isTitleMultilingual: PropTypes.bool,
      activeTab: PropTypes.string,
      alignStatInfos: PropTypes.string,
      alignActions: PropTypes.string,
      tabs: PropTypes.array,
      contentFilters: PropTypes.array,
      keywordSearch: PropTypes.string,
      filters: PropTypes.array,
      filterActions: PropTypes.array,
      hasFilter: PropTypes.bool,
      hasSearch: PropTypes.bool,
      placeholderSearch: PropTypes.string,
      favoriteTab: PropTypes.string,
      rightActions: PropTypes.array,
      activeContentFilters: PropTypes.array,
      onGridListToggle: PropTypes.func,
      onTabChange: PropTypes.func,
      onToggleFavorite: PropTypes.func,
      onContentFilterChange: PropTypes.func,
      onChange: PropTypes.func,
      onSearchTags: PropTypes.func,
      onClickSubtitle: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      projectSetting: null,
      projectNumber: '',
      title: '',
      subtitle: '',
      icon: {},
      statInfos: [],
      showGridList: false,
      isGridActive: true,
      actions: [],
      showTabs: false,
      isTitleMultilingual: true,
      activeTab: '',
      alignStatInfos: 'top',
      alignActions: 'title',
      tabs: [],
      contentFilters: [],
      keywordSearch: '',
      filters: [],
      filterActions: [],
      hasFilter: false,
      hasSearch: false,
      placeholderSearch: '',
      favoriteTab: '',
      rightActions: [],
      activeContentFilters: [],
      onGridListToggle: null,
      onTabChange: null,
      onToggleFavorite: null,
      onContentFilterChange: null,
      onChange: null,
      onSearchTags: null,
      onClickSubtitle: null
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    const nextPanel = this._getNextPannel(nextProps)

    if (
      this._canAutoOpenFilter &&
      (nextPanel !== this.data.currentPanel ||
        this.data.keywordSearch !== nextProps.keywordSearch)
    ) {
      this.data.currentPanel = nextPanel
      this.data.keywordSearch = nextProps.keywordSearch
      this._canAutoOpenFilter = false

      this.setState({ dataDate: new Date() })
    }

    if (!_.isEqual(nextProps.actions, this.props.actions)) {
      // Create references for actions if action has confirmation
      this._createReferencesForActions(nextProps.actions, 'action')
    }

    if (!_.isEqual(nextProps.rightActions, this.props.rightActions)) {
      // Create references for rightActions if action has confirmation
      this._createReferencesForActions(nextProps.rightActions, 'rightaction')
    }
  }

  canShowSearch () {
    const { currentPanel } = this.data
    return (
      currentPanel !== 'filtersearch' &&
      (currentPanel === 'main' || currentPanel === 'filtermain')
    )
  }

  showSearch () {
    this._onChangeFilterPanel('filtersearch')
  }

  disableAutoOpenFilter () {
    this._canAutoOpenFilter = false
  }

  onEscKeyDown () {
    const { currentPanel } = this.data
    if (currentPanel === 'filtersearch') {
      this._onCloseSearch()
    } else if (currentPanel === 'filtermain') {
      this._onChangeFilterPanel('main')
    } else if (currentPanel !== 'main') {
      this._onChangeFilterPanel('filtermain')
    }
  }

  showSuccess (title, subtitle) {
    this.data.message = {
      title: title,
      subtitle: subtitle,
      type: 'success'
    }
    this._onChangeFilterPanel('message')

    if (this._messageTime) window.clearTimeout(this._messageTime)

    this._messageTime = window.setTimeout(() => {
      this.data.message = null
      this._onChangeFilterPanel('main')
    }, 3000)
  }

  showError (title, subtitle) {
    this.data.message = {
      title: title,
      subtitle: subtitle,
      type: 'error'
    }

    this._onChangeFilterPanel('message')

    if (this._messageTime) window.clearTimeout(this._messageTime)

    this._messageTime = window.setTimeout(() => {
      this.data.message = null
      this._onChangeFilterPanel('main')
    }, 3000)
  }

  /* Private functions */
  _createReferencesForActions (actions, prefix = 'action') {
    if (actions && actions.length > 0) {
      actions.forEach(action => {
        if (
          action.hasConfirm &&
          !this._references[`action-confirm-${action.ident}`]
        ) {
          this._references[
            `${prefix}-confirm-${action.ident}`
          ] = React.createRef()
        }
      })
    }
  }

  /* Event Handlers */
  _onChangeFilterPanel (panel) {
    this.data.currentPanel = panel
    this._canAutoOpenFilter = false
    this.data.options = []

    this.setState({ dataDate: new Date() })
  }

  _getNextPannel (props) {
    if (this.data && this.data.currentPanel !== 'main') {
      return this.data.currentPanel
    }

    let currentPanel = 'main'

    if (props.keywordSearch) {
      currentPanel = 'filtersearch'
    } else {
      const isFilterActive =
        _.findIndex(props.filters, filter => {
          let isActive = false

          if (filter.type === 'tag') {
            if (filter.isMulti) {
              isActive = !!(filter.value && filter.value.length > 0)
            } else if (filter.value) {
              isActive = true
            }
          } else if (filter.type === 'date') {
            if (filter.value) {
              if (filter.isMulti) {
                isActive = !!filter.value.value
              } else {
                isActive = true
              }
            }
          } else if (filter.type === 'option' || !filter.isMulti) {
            isActive = !!(filter.value && filter.value !== filter.defaultValue)
          }

          return isActive
        }) >= 0

      if (isFilterActive) {
        currentPanel = 'filtermain'
      }
    }

    return currentPanel
  }

  _onSelectFilter (filterIdent) {
    this.data.currentFilterIdent = filterIdent

    const { filters } = this.props
    const currentFilter = _.find(filters, obj => obj.ident === filterIdent)

    this.data.keywordTag = ''
    if (
      currentFilter &&
      currentFilter.type === 'tag' &&
      !currentFilter.isMulti &&
      currentFilter.value
    ) {
      this.data.keywordTag = currentFilter.value.label
    }

    this._onChangeFilterPanel('filter')
  }

  _onDeleteFilter (filterIdent, ev) {
    ev.preventDefault()
    ev.stopPropagation()

    const { filters } = this.props
    const currentFilter = _.find(filters, obj => obj.ident === filterIdent)

    if (currentFilter) {
      currentFilter.value = ''
    }

    this._onChangeFilter(filters)
    this.setState({ dataDate: new Date() })
  }

  _onChangeOptionFilter (filterIdent, option) {
    const { filters } = this.props
    const currentFilter = _.find(filters, obj => obj.ident === filterIdent)

    if (currentFilter) {
      currentFilter.value =
        option.ident !== currentFilter.defaultValue ? option.ident : currentFilter.defaultValue
    }

    this._onChangeFilter(filters)
    this._onChangeFilterPanel('filtermain')
  }

  _onChangeFilter (filters) {
    const filter = {}
    const { hasSearch, onChange } = this.props

    if (filters && filters.length > 0) {
      filters.forEach(item => {
        if (item.type !== 'label' && item.value) {
          if (item.type === 'tag' && item.isMulti) {
            if (item.value && item.value.length > 0) {
              filter[item.ident] = []
              item.value.forEach(tag => {
                if (tag) {
                  filter[item.ident].push(tag)
                }
              })
            }
          } else {
            filter[item.ident] = item.value
          }
        }
      })
    }

    if (hasSearch) {
      filter.keyword = this.data.keywordSearch || ''
    }

    if (onChange) {
      onChange(filter)
    }
  }

  _getCurrentFilter () {
    return _.find(
      this.props.filters,
      obj => obj.ident === this.data.currentFilterIdent
    )
  }

  _onSearchTags (keyword) {
    this.data.keywordTag = keyword
    this.setState({ focusedIndex: -1, dataDate: new Date() })

    const { currentFilterIdent } = this.data

    if (this.props.onSearchTags) {
      this.props.onSearchTags(currentFilterIdent, keyword, options => {
        // Check whether filter is chagned
        if (currentFilterIdent === this.data.currentFilterIdent) {
          this.data.options = options || []
          this.setState({ dataDate: new Date() })
        }
      })
    }
  }

  _onSearchKeyDown (ev) {
    const { options } = this.data
    let { focusedIndex } = this.state
    const keyCode = ev.keyCode || 0

    if (keyCode === 40 || keyCode === 38) {
      const value = keyCode === 40 ? 1 : -1
      focusedIndex = this._getNextFocus(options, focusedIndex, value)

      this.setState({ focusedIndex })
    } else if (keyCode === 13) {
      ev.preventDefault()
      ev.stopPropagation()

      if (focusedIndex !== -1) {
        this._onSelectTag(options[focusedIndex])
      }
    }
  }

  _getNextFocus (options, focusedIndex, incr) {
    const totalOptions = options.length
    const idx = 0

    // eslint-disable-next-line no-unmodified-loop-condition
    while (idx < totalOptions) {
      focusedIndex += incr

      if (focusedIndex < 0) {
        focusedIndex = totalOptions - 1
      } else if (focusedIndex === totalOptions) {
        focusedIndex = 0
      }

      if (options[focusedIndex] && !options[focusedIndex].bArchived) {
        return focusedIndex
      }
    }

    return -1
  }

  _onSaveTag () {
    if (!this.data.keywordTag) {
      this._onSelectTag(null)
    }

    this._onChangeFilterPanel('filtermain')
  }

  _onSelectTag (option) {
    const { filters } = this.props
    const { currentFilterIdent } = this.data
    const currentFilter = _.find(
      filters,
      obj => obj.ident === currentFilterIdent
    )

    if (currentFilter) {
      if (currentFilter.isMulti) {
        if (!currentFilter.value) {
          currentFilter.value = []
        }

        if (option) {
          currentFilter.value.push(option)
        }

        this.data.keywordTag = ''
        this.data.options = []

        this.setState({ dataDate: new Date(), focusedIndex: -1 })
      } else {
        currentFilter.value = option

        this.data.keywordTag = option ? option.label : ''
        this.data.options = []

        this.setState({ dataDate: new Date(), focusedIndex: -1 })
      }
    } else {
      this.setState({ focusedIndex: -1 })
    }

    this._onChangeFilter(filters)
  }

  _onDeleteTag (option) {
    const { filters } = this.props
    const { currentFilterIdent } = this.data
    const currentFilter = _.find(
      filters,
      obj => obj.ident === currentFilterIdent
    )

    if (currentFilter) {
      if (currentFilter.isMulti) {
        if (!currentFilter.value) {
          currentFilter.value = []
        }

        _.remove(currentFilter.value, obj => obj.value === option.value)

        this.setState({ dataDate: new Date() })
        this._onChangeFilter(filters)
      }
    }
  }

  _onChangeDateMulti (name, date) {
    const { filters } = this.props
    const { currentFilterIdent } = this.data
    const currentFilter = _.find(
      filters,
      obj => obj.ident === currentFilterIdent
    )

    if (currentFilter) {
      const newDateFilter = currentFilter.value || {
        ident: 'custom',
        label: '',
        value: {
          from: null,
          to: null
        }
      }

      newDateFilter.ident = 'custom'

      const newDate = convertToRangedDateLocalTime(name, date)

      newDateFilter.value[name] = newDate

      if (newDateFilter.value.from || newDateFilter.value.to) {
        currentFilter.value = newDateFilter
      } else {
        currentFilter.value = null
      }

      this.setState({ dataDate: new Date() })
    }

    this._onChangeFilter(filters)
  }

  _onChangeDate (date) {
    const { filters } = this.props
    const { currentFilterIdent } = this.data
    const currentFilter = _.find(
      filters,
      obj => obj.ident === currentFilterIdent
    )

    if (currentFilter) {
      currentFilter.value = {
        ident: 'custom',
        label: '',
        value: date
      }

      this.setState({ dataDate: new Date() })
    }

    this._onChangeFilter(filters)
  }

  _onSelectDateOption (dateOption) {
    const { filters } = this.props
    const { currentFilterIdent } = this.data
    const currentFilter = _.find(
      filters,
      obj => obj.ident === currentFilterIdent
    )

    if (currentFilter) {
      currentFilter.value = dateOption

      this.setState({ dataDate: new Date() })
    }

    this._onChangeFilter(filters)
  }

  _getDateFilterLabel (filter) {
    if (!filter || !filter.value) return ''

    const dateFilter = filter.value
    if (dateFilter.ident !== 'custom') {
      return dateFilter.label
        ? `${IntlUtil.convertMessage(dateFilter.label)}${
            dateFilter.subtitle ? ' ' + dateFilter.subtitle : ''
          }`
        : dateFilter.ident
    }

    if (!filter.isMulti) {
      return DateUtil.getDisplayDate(filter.value.value)
    }

    if (dateFilter.value.from && dateFilter.value.to) {
      return (
        ` ${IntlUtil.convertMessage(
          'estimate.form.labelFrom'
        )} ${DateUtil.getDisplayDate(dateFilter.value.from)}` +
        ` ${IntlUtil.convertMessage(
          'estimate.form.labelUntil'
        )} ${DateUtil.getDisplayDate(dateFilter.value.to)}`
      )
    } else if (dateFilter.value.from) {
      return `${IntlUtil.convertMessage(
        'estimate.form.labelOn'
      )} ${DateUtil.getDisplayDate(dateFilter.value.from)}`
    } else if (dateFilter.value.to) {
      return `${IntlUtil.convertMessage(
        'estimate.form.labelOn'
      )} ${DateUtil.getDisplayDate(dateFilter.value.to)}`
    }

    return ''
  }

  _onSearchKeyword (value) {
    this.data.keywordSearch = value
    this.setState({ dataDate: new Date() })

    if (this._timerSearchKeyword) {
      window.clearTimeout(this._timerSearchKeyword)
      this._timerSearchKeyword = null
    }

    this._timerSearchKeyword = window.setTimeout(() => {
      this._onChangeFilter(this.props.filters)
    }, 1500)
  }

  _onCloseSearch () {
    this.data.keywordSearch = ''
    this._onChangeFilterPanel('main')

    if (this._timerSearchKeyword) {
      window.clearTimeout(this._timerSearchKeyword)
      this._timerSearchKeyword = null
    }

    this._onChangeFilter(this.props.filters)
  }

  _showActionConfirm (action, prefix = 'action') {
    const confirmRef = this._references[`${prefix}-confirm-${action.ident}`]
    if (confirmRef.current) {
      confirmRef.current.show()
    }
  }

  _onConfirmAction (action, ev) {
    if (action.onClick) {
      action.onClick(ev)
    }
  }

  /* Render - Main Content Functions - START */
  _renderMainContent () {
    const { currentPanel } = this.data
    if (currentPanel !== 'main') {
      return null
    }

    const { alignStatInfos } = this.props

    return (
      <div className='cpage-header-content'>
        <div className='inner-content layoutrow'>
          <div className='maininfo layoutcolfull'>
            {this._renderTitleInfo()}
            {this._renderActions()}
          </div>
          {alignStatInfos === 'top' && (
            <div className='layoutcol'>{this._renderStatInfo()}</div>
          )}
          {this._renderRightActions()}
        </div>
        <div className='navig layoutrow'>
          {alignStatInfos === 'bottom' && (
            <div className='layoutcol'>{this._renderStatInfo()}</div>
          )}
          <div className='layoutcolfull'>{this._renderTabs()}</div>
          <div className='contentfilters'>
            {this._renderContentFilters()}
            {this._renderGridListToggle()}
          </div>
        </div>
      </div>
    )
  }

  _renderTitleInfo () {
    const {
      projectSetting,
      projectNumber,
      title,
      subtitle,
      icon,
      isTitleMultilingual,
      onClickSubtitle
    } = this.props
    return (
      <div className='titleinfo layoutrow'>
        <div className='menu-icon'>
          {icon}
        </div>
        <div className='title layoutcolfull'>
          <h1>
            {projectSetting &&
              projectSetting.useProjectNo &&
              projectNumber &&
              projectNumber + ' / '}
            {isTitleMultilingual && title ? (
              <IntlMessage ident={title} />
            ) : (
              title
            )}
          </h1>
          {subtitle && (
            <div
              className={`subtitle${onClickSubtitle ? ' hasclick' : ''}`}
              onClick={onClickSubtitle}
            >
              {isTitleMultilingual ? (
                <IntlMessage ident={subtitle} />
              ) : (
                subtitle
              )}
            </div>
          )}
        </div>
      </div>
    )
  }

  _renderActions () {
    const { actions, hasFilter, hasSearch, alignActions } = this.props

    if (actions.length <= 0 && !hasFilter) {
      return null
    }

    return (
      <div className={`actions actions_${alignActions || 'title'}`}>
        {hasFilter && (
          <IconButton
            icon='filter'
            type='primary'
            className='filteractionbutton'
            tooltip='common.list.tipFilterOpen'
            tooltipPosition='bottom'
            onClick={this._onChangeFilterPanel.bind(this, 'filtermain')}
          />
        )}
        {hasSearch && (
          <IconButton
            icon='search'
            type='primary'
            className='filteractionbutton'
            tooltip='common.list.tipSearch'
            tooltipPosition='bottom'
            onClick={this._onChangeFilterPanel.bind(this, 'filtersearch')}
          />
        )}
        {actions.map(action => {
          const { ident, type, hasConfirm, onClick, ...others } = action
          return (
            <React.Fragment key={ident}>
              {type === 'button' ? (
                <Button
                  key={ident}
                  onClick={
                    hasConfirm
                      ? this._showActionConfirm.bind(this, action)
                      : onClick
                  }
                  {...others}
                />
              ) : type === 'info' ? (
                <div
                  className={`actioninfo${onClick ? ' hasclick' : ''}`}
                  onClick={onClick}
                >
                  <span dangerouslySetInnerHTML={{ __html: action.title }} />
                </div>
              ) : (
                <IconButton
                  key={ident}
                  type='primary'
                  className='filteractionbutton'
                  onClick={
                    hasConfirm
                      ? this._showActionConfirm.bind(this, action)
                      : onClick
                  }
                  {...others}
                />
              )}
              {action.hasConfirm && (
                <ConfirmDelete
                  ref={this._references[`action-confirm-${action.ident}`]}
                  className='confirmdelete'
                  title={action.confirmTitle}
                  onClickOk={this._onConfirmAction.bind(this, action)}
                />
              )}
            </React.Fragment>
          )
        })}
      </div>
    )
  }

  _renderRightActions () {
    const { rightActions } = this.props
    if (!rightActions || rightActions.length <= 0) {
      return null
    }

    return (
      <div className='actions actions_right layoutcol'>
        {rightActions.map(action => {
          const { ident, hasConfirm, onClick, isLoading, ...others } = action
          const isLight = others.className?.includes('lightbg') ?? false

          return (
            <React.Fragment key={ident}>
              <IconButton
                className='filterbutton'
                onClick={
                  hasConfirm
                    ? this._showActionConfirm.bind(this, action, 'rightaction')
                    : onClick
                }
                {...others}
              >
                {isLoading ? <Spinner size={28} color={isLight ? '#1e4564' : '#fff'} /> : null}
              </IconButton>
              {action.hasConfirm && (
                <ConfirmDelete
                  ref={this._references[`rightaction-confirm-${action.ident}`]}
                  className='confirmdelete'
                  title={action.confirmTitle}
                  onClickOk={this._onConfirmAction.bind(this, action)}
                />
              )}
            </React.Fragment>
          )
        })}
      </div>
    )
  }

  _renderStatInfo () {
    const { statInfos, alignStatInfos } = this.props

    if (statInfos.length <= 0) {
      return null
    }

    return (
      <div className={`stats stats_${alignStatInfos}`}>
        {statInfos.map((stat, idx) => (
          <div
            key={idx}
            className={classnames('stat', {
              hasprogress: stat.progress >= 0,
              active: stat.active,
              hasclick: stat.onClick
            })}
            onClick={stat.onClick} // eslint-disable-line react/jsx-handler-names
          >
            <div className='title'>
              {stat.isMultilingual !== undefined && !stat.isMultilingual ? (
                stat.title
              ) : (
                <IntlMessage ident={stat.title} />
              )}
            </div>
            {stat.value !== undefined && (
              <div className='value'>
                {stat.isPrice
                  ? currency.formatSymbol(stat.value || 0)
                  : stat.value}
              </div>
            )}

            {stat.options && stat.options.length > 0 && (
              <div className='options'>
                {stat.options.map((option, idx) => (
                  <span
                    key={idx}
                    className={`item item_${option.type}${
                      option.active ? ' active' : ''
                    }`}
                  >
                    {option.value}
                  </span>
                ))}
              </div>
            )}
            {stat.subtitle && <div className='subtitle'>{stat.subtitle}</div>}
            {stat.progress !== undefined && (
              <div className='progress-bar'>
                <ProgressBar
                  value={stat.progress}
                  showWarningColor={stat?.showWarningColorInProgressBar}
                />
              </div>
            )}
            {stat.tooltipInfos && stat.tooltipInfos.length > 0 && (
              <div className='stattooltipwrap'>
                <IconButton
                  icon='info'
                  className='headerinfo'
                  size='small'
                  iconSize='16'
                  onRenderTooltip={currentEl => (
                    <Tooltip trigger={currentEl} position='left'>
                      {stat.tooltipInfos.map((row, idx) => {
                        const rowClassname = classnames('stattip-row', {
                          hassplitter: row.hasSpliter,
                          'splitter-width-70': row.splitterWidth === 70,
                          'align-row-right': !row.alignRow || row.alignRow === 'right',
                          'align-row-left': row.alignRow === 'left'
                        })

                        return (
                          <div className={rowClassname} key={idx}>
                            {row.items.map((item, idx) => (
                              <div
                                className={`stattip-item align${item.align || 'left'} ${item.className || ''}`}
                                key={idx}
                              >
                                <div className='content'>
                                  {item.title && (
                                    <div className='title'>
                                      <IntlMessage ident={item.title} />
                                    </div>
                                  )}
                                  <div className='value'>
                                    {item.showWarning && (
                                      <IconButton
                                        icon='edit'
                                        type='warning'
                                        size='small'
                                        className='actwarning'
                                      />
                                    )}
                                    <span>
                                      {item.isPrice ? currency.formatSymbol(item.value || 0) : item.value}
                                    </span>
                                  </div>
                                </div>
                                {item.suffixText && (
                                  <div className='suffix'>{item.suffixText}</div>
                                )}
                              </div>
                            ))}
                          </div>
                        )
                    })}
                    </Tooltip>
                  )}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    )
  }

  _renderTabs () {
    const {
      tabs,
      activeTab,
      favoriteTab,
      onTabChange,
      onToggleFavorite
    } = this.props

    if (tabs.length <= 0) {
      return null
    }

    return (
      <ul className='tabs'>
        {tabs.map(tab => {
          const isActive = activeTab === tab.ident

          return (
            <li
              key={tab.ident}
              className={`tabitem${isActive ? ' active' : ''}`}
              onClick={ev => (onTabChange ? onTabChange(tab, ev) : null)}
            >
              {tab.icon && <SvgIcon name={tab.icon} className='tabicon' />}
              {tab.showFavourite && (
                <SvgIcon
                  name={tab.ident === favoriteTab ? 'fav' : 'nonfav'}
                  size='8'
                  className={`tabicon${
                    tab.ident === favoriteTab ? ' favorite' : ''
                  }`}
                  onClick={
                    isActive && onToggleFavorite
                      ? ev => onToggleFavorite(tab, ev)
                      : null
                  }
                />
              )}
              <span className='tabtitle'>
                <IntlMessage ident={tab.title} />
              </span>
            </li>
          )
        })}
      </ul>
    )
  }

  _renderGridListToggle () {
    const { showGridList, isGridActive, onGridListToggle } = this.props

    if (!showGridList) {
      return null
    }

    return (
      <IconButton
        icon={isGridActive ? 'tiles' : 'rows'}
        type='primary'
        className='filteractionbutton'
        onClick={ev => onGridListToggle & onGridListToggle(!isGridActive, ev)}
      />
    )
  }

  _renderContentFilters () {
    const {
      contentFilters,
      activeContentFilters,
      onContentFilterChange
    } = this.props

    if (contentFilters.length <= 0) {
      return null
    }

    return contentFilters.map((item, idx) => (
      <div
        className={`actionitem${
          activeContentFilters && activeContentFilters.indexOf(item.ident) >= 0
            ? ' active'
            : ''
        }`}
        key={idx}
        onClick={ev => onContentFilterChange && onContentFilterChange(item, ev)}
      >
        <IntlMessage ident={item.title} />
      </div>
    ))
  }
  /* Render - Main Content Functions - END */

  /* Render - Filter Content Functions - START */
  _renderFilterContent () {
    const { currentPanel } = this.data
    if (currentPanel === 'main') {
      return null
    }

    return (
      <div className='cpage-header-filter'>
        {this._renderFilterPanelMain()}
        {this._renderFilterPanelContent()}
        {this._renderFilterPanelSearch()}
      </div>
    )
  }

  _renderFilterPanelMain () {
    const { currentPanel } = this.data
    const { filters, filterActions } = this.props

    if (currentPanel !== 'filtermain') {
      return null
    }

    return (
      <div className='filterpanel filterpanel-main layoutrow'>
        <div className='layoutcolfull'>
          <div className='filterlist'>
            {filters.map((filter, idx) => {
              const isFilter = filter.type !== 'label'
              let isActive = false
              let titleElement = <IntlMessage ident={filter.label} />

              if (filter.type === 'tag') {
                if (filter.isMulti) {
                  if (filter.value && filter.value.length > 0) {
                    isActive = true
                    titleElement = filter.value
                      .map(obj => (obj ? obj.value : ''))
                      .join(', ')
                  } else {
                    isActive = false
                  }
                } else {
                  if (filter.value) {
                    isActive = true
                    titleElement = filter.value.label
                  } else {
                    isActive = false
                  }
                }
              } else if (filter.type === 'date') {
                if (filter.value) {
                  titleElement =
                    this._getDateFilterLabel(filter) || titleElement

                  if (filter.isMulti) {
                    isActive = !!(
                      filter.value.value &&
                      (filter.value.value.from || filter.value.value.to)
                    )
                  } else {
                    isActive = true
                  }
                }
              } else if (filter.type === 'option' || !filter.isMulti) {
                isActive = !!(
                  filter.value && filter.value !== filter.defaultValue
                )

                const selectedItem = _.find(
                  filter.options,
                  obj => obj.ident === (filter.value || filter.defaultValue)
                )
                if (filter.type === 'option' && filter.value && selectedItem) {
                  titleElement = <IntlMessage ident={selectedItem.label} />
                }
              }

              const itemClass = classnames('item', {
                link: isFilter,
                active: isActive
              })

              return (
                <div
                  className={itemClass}
                  key={idx}
                  onClick={
                    isFilter
                      ? this._onSelectFilter.bind(this, filter.ident)
                      : null
                  }
                >
                  <span className='title'>{titleElement}</span>
                  {isFilter && isActive && (
                    <IconButton
                      icon='x'
                      type='error'
                      className='filterdelete'
                      iconSize='8'
                      onClick={this._onDeleteFilter.bind(this, filter.ident)}
                    />
                  )}
                </div>
              )
            })}
          </div>
          <div className='filterinfo'>
            <IntlMessage ident='common.list.filterInfo' />
          </div>
        </div>
        <div className='actions'>
          {filterActions &&
            filterActions.map(action => (
              <IconButton
                key={action.ident}
                type='invert'
                size='big'
                {...action}
              />
            ))}
          <IconButton
            icon='x'
            type='invert'
            size='big'
            iconSize='16'
            onClick={this._onChangeFilterPanel.bind(this, 'main')}
          />
        </div>
      </div>
    )
  }

  _renderFilterPanelContent () {
    const { currentPanel } = this.data
    const currentFilter = this._getCurrentFilter()

    if (currentPanel !== 'filter' || !currentFilter) {
      return null
    }

    if (currentFilter.type === 'option') {
      return this._renderFilterPanelOptions(currentFilter)
    } else if (currentFilter.type === 'tag') {
      return this._renderFilterPanelTags(currentFilter)
    } else if (currentFilter.type === 'date') {
      return this._renderFilterPanelDate(currentFilter)
    }

    return null
  }

  _renderFilterPanelOptions () {
    const currentFilter = this._getCurrentFilter()
    if (
      !currentFilter ||
      !currentFilter.options ||
      currentFilter.options.length <= 0
    ) {
      return null
    }

    const activeIdent = currentFilter.value || currentFilter.defaultValue

    return (
      <div className='filterpanel filterpanel-options layoutrow'>
        <div className='options layoutcolfull'>
          {currentFilter.options.map(option => (
            <div
              key={option.ident}
              className={`item${option.ident === activeIdent ? ' active' : ''}`}
              onClick={this._onChangeOptionFilter.bind(
                this,
                currentFilter.ident,
                option
              )}
            >
              <IntlMessage ident={option.label} />
            </div>
          ))}
        </div>
        <div className='actions'>
          <IconButton
            icon='done'
            type='success'
            size='big'
            onClick={this._onChangeFilterPanel.bind(this, 'filtermain')}
          />
        </div>
      </div>
    )
  }

  _renderFilterPanelTags () {
    const { keywordTag } = this.data
    const currentFilter = this._getCurrentFilter()

    if (!currentFilter) {
      return null
    }

    const totalTags = currentFilter.value ? currentFilter.value.length : 0

    return (
      <div className='filterpanel filterpanel-tags'>
        <div className='filterpanelcont layoutrow'>
          <div className='layoutcolfull'>
            <div className='tagfield'>
              <Input
                styleType='headerinput'
                name='keyword'
                type='text'
                placeholder={currentFilter.placeholder}
                maxLength={128}
                autoFocus
                value={keywordTag}
                onChange={this._onSearchTags.bind(this)}
                onKeyDown={this._onSearchKeyDown.bind(this)}
              />
              {this._renderSearchOptions()}
            </div>
            <div className='filterinfo'>
              <IntlMessage ident='common.list.searchInfo' />
            </div>
            {currentFilter.isMulti &&
              (currentFilter.value && currentFilter.value.length > 0 ? (
                <div className='filtertags'>
                  {currentFilter.value.map((tag, idx) => (
                    <div className='tagitem' key={idx}>
                      <span className='title'>{tag.label}</span>
                      <IconButton
                        className='deleteicon'
                        icon='x'
                        type='error'
                        iconSize='6'
                        size='small'
                        onClick={this._onDeleteTag.bind(this, tag)}
                      />
                      <span className='taglabel'>
                        {idx === totalTags - 2 ? (
                          <IntlMessage ident='common.list.andSplitter' />
                        ) : (
                          ', '
                        )}
                      </span>
                    </div>
                  ))}
                </div>
              ) : (
                <div className='filtermessage'>
                  <IntlMessage ident='common.list.searchTagInfo' />
                </div>
              ))}
          </div>
          <div className='actions'>
            <IconButton
              icon='done'
              size='big'
              type='success'
              onClick={this._onSaveTag.bind(this)}
            />
          </div>
        </div>
      </div>
    )
  }

  _renderSearchOptions () {
    const { options } = this.data
    if (options.length <= 0) {
      return null
    }
    const { focusedIndex } = this.state

    return (
      <div className='filtersearchlist'>
        {options.map((option, idx) => (
          <div
            key={`${option.value}-${idx}`}
            className={`item${focusedIndex === idx ? ' focusitem' : ''}`}
            onClick={this._onSelectTag.bind(this, option)}
          >
            {option.label}
          </div>
        ))}
      </div>
    )
  }

  _renderFilterPanelSingleDate () {
    const currentFilter = this._getCurrentFilter()
    const valueDate = currentFilter.value
    const defaultValue = currentFilter.defaultValue
    const selectedOption =
      valueDate && valueDate.value
        ? valueDate.ident
        : defaultValue
        ? defaultValue.ident
        : ''

    return (
      <div className='filterpanel filterpanel-date'>
        <div className='filterpanelcont'>
          <div className='layoutcolfull'>
            <div className='filterdaterange layoutrow'>
              <div className='filterdateto layoutcolfull'>
                <FormDatePicker
                  icon='header-calendar'
                  size='big'
                  hideDatePickerIcon
                  showPlaceholder
                  placeholder='common.list.datePlaceholder'
                  value={valueDate && valueDate.value ? valueDate.value : null}
                  onChange={this._onChangeDate.bind(this)}
                />
                <div className='filterinfo'>
                  <IntlMessage ident='common.list.searchInfo' />
                </div>
              </div>
              <div className='actions'>
                <IconButton
                  icon='done'
                  type='success'
                  size='big'
                  className='filtersave'
                  onClick={this._onChangeFilterPanel.bind(this, 'filtermain')}
                />
              </div>
            </div>
            {currentFilter.dateOptions && (
              <div className='filteroptions'>
                {currentFilter.dateOptions.map(dateOpt => (
                  <div
                    key={dateOpt.ident}
                    className={`item${
                      dateOpt.ident === selectedOption ? ' active' : ''
                    }`}
                    onClick={this._onSelectDateOption.bind(this, dateOpt)}
                  >
                    <IntlMessage ident={dateOpt.label} />
                    {dateOpt.subtitle ? ' ' + dateOpt.subtitle : ''}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  _renderFilterPanelDate () {
    const currentFilter = this._getCurrentFilter()
    const defaultValue = currentFilter.defaultValue
    if (!currentFilter) {
      return null
    }

    if (!currentFilter.isMulti) {
      return this._renderFilterPanelSingleDate()
    }

    const valueDate = currentFilter.value

    return (
      <div className='filterpanel filterpanel-date'>
        <div className='filterpanelcont'>
          <div className='layoutcolfull'>
            <div className='filterdaterange layoutrow'>
              <div className='filterdatefrom layoutcolfull'>
                <FormDatePicker
                  icon='header-calendar'
                  size='big'
                  showPlaceholder
                  placeholder='common.list.datePlaceholder'
                  value={
                    valueDate && valueDate.value ? valueDate.value.from : null
                  }
                  onChange={this._onChangeDateMulti.bind(this, 'from')}
                />
                <div className='filterinfo'>
                  <IntlMessage ident='common.list.searchInfo' />
                </div>
              </div>
              <div className='filterdateto layoutcolfull'>
                <FormDatePicker
                  icon='header-calendar'
                  size='big'
                  showPlaceholder
                  placeholder='common.list.datePlaceholder'
                  value={
                    valueDate && valueDate.value ? valueDate.value.to : null
                  }
                  onChange={this._onChangeDateMulti.bind(this, 'to')}
                />
              </div>
              <div className='actions'>
                <IconButton
                  icon='done'
                  type='success'
                  size='big'
                  className='filtersave'
                  onClick={this._onChangeFilterPanel.bind(this, 'filtermain')}
                />
              </div>
            </div>
            {currentFilter.dateOptions && (
              <div className='filteroptions'>
                {currentFilter.dateOptions.map(dateOpt => (
                  <div
                    key={dateOpt.ident}
                    className={`item${
                      (valueDate && dateOpt.ident === valueDate.ident) ||
                      (defaultValue &&
                        defaultValue.ident === dateOpt.ident &&
                        !(valueDate && valueDate.ident))
                        ? ' active'
                        : ''
                    }`}
                    onClick={this._onSelectDateOption.bind(this, dateOpt)}
                  >
                    <IntlMessage ident={dateOpt.label} />
                    {dateOpt.subtitle ? ' ' + dateOpt.subtitle : ''}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  _renderFilterPanelSearch () {
    const { currentPanel, keywordSearch } = this.data
    const { placeholderSearch, filterActions } = this.props

    if (currentPanel !== 'filtersearch') {
      return null
    }

    return (
      <div className='filterpanel filterpanel-search'>
        <div className='filterpanelcont layoutrow'>
          <div className='searchfield layoutcolfull'>
            <Input
              styleType='searchinput'
              name='keyword'
              type='text'
              placeholder={placeholderSearch}
              maxLength={128}
              autoFocus
              value={keywordSearch}
              onChange={this._onSearchKeyword.bind(this)}
            />
          </div>
          <div className='searchclose'>
            {filterActions && filterActions.map(action => (
              <IconButton
                key={action.ident}
                type='invert'
                size='big'
                {...action}
              />
            ))}
            <IconButton
              icon='x'
              type='invert'
              size='big'
              iconSize='16'
              onClick={this._onCloseSearch.bind(this)}
            />
          </div>
        </div>
      </div>
    )
  }

  _renderMessageContent () {
    const { message, currentPanel } = this.data

    if (currentPanel !== 'message') {
      return null
    }
    const type = message.type
    return (
      <div className={`filterpanel filterpanel-message ${type}`}>
        <div className='content'>
          <div className='title'>
            <IntlMessage ident={message.title} />
          </div>
          <input style={{ opacity: 0 }} autoFocus />
          <div className='subtitle'>
            <IntlMessage ident={message.subtitle} />
          </div>
        </div>
      </div>
    )
  }
  /* Render - Filter Content Functions - END */

  render () {
    return (
      <div className='cpage-header'>
        {this._renderMainContent()}
        {this._renderFilterContent()}
        {this._renderMessageContent()}
      </div>
    )
  }
}

export default PageHeader
